import { useMutation } from "@tanstack/react-query";

import {  savePostCourseAssessment } from "./utils.api";

export const useSavePostCourseAssessment = () =>
    useMutation({
        mutationFn: (body) =>
            savePostCourseAssessment(body),
    });